import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-ink-900 group-[.toaster]:border-2 group-[.toaster]:border-grid-300 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-ink-600",
          actionButton:
            "group-[.toast]:bg-imperial-600 group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-grid-100 group-[.toast]:text-ink-600",
        },
      }}
      position="top-right"
      richColors
      {...props}
    />
  );
};

export { Toaster };
